<template>
  <div :class="[{'fake-input-active': isActive}, 'fake-input']" @click="$emit('click')">
    <div class="fake-input-placeholder" v-if="!value">{{placeholder}}</div>
    <div class="fake-input-value">{{value}}</div>
    <div class="fake-input-btn">{{ $bp_t('选择', 'common.choice') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: { type: Boolean, default: false },
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.fake-input {
  height: 34px;
  width: 210px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  position: relative;
  line-height: 20px;

  .fake-input-placeholder {
    color: $color-text-holder;
  }

  .fake-input-value {
    color: $color-border-underline;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .fake-input-btn {
    cursor: pointer;
    color: $color-active-light;
    font-size: 14px;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

   &:hover {
    border-color: #2f88ff !important;
  }

  &.fake-input-active {
    border-color: #2f88ff !important;
    box-shadow: 0 0 0 2px rgba(47, 136, 255, 0.2);
  }
}
</style>